<template>
  <span class="text-danger small">{{ text }}</span>
</template>

<script>
export default {
  props: ["text"],
};
</script>
